// © Microsoft Corporation. All rights reserved.

import { DesignSystem, neutralForegroundRest, neutralLayerCard } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";

const shadow = "0px 0px 5px rgb(0 0 0 / 10%), 0 8px 14px 0px rgb(0 0 0 / 15%)";
const arrowWidth = 10;

export const ProfileEducatorStyles = (config: DesignSystem) => ({
    profileEducator: {
        position: "relative",
        display: "flex",
        "flex-direction": "column",
        width: "200px",
        padding: "12px 16px",
        background: neutralLayerCard,
        "border-radius": "4px",
        "-webkit-box-shadow": shadow,
        "-moz-box-shadow": shadow,
        "box-shadow": shadow,
        color: neutralForegroundRest,

        "&:after": {
            position: "absolute",
            [applyLocalizedProperty("left", "right", config.direction)]: `${arrowWidth}px`,
            bottom: `-${arrowWidth}px`,
            content: "' '",
            display: "block",
            width: "0",
            height: "0",
            "border-left": `${arrowWidth}px solid transparent`,
            "border-right": `${arrowWidth}px solid transparent`,
            "border-top": `${arrowWidth}px solid white`,
            "border-top-color": neutralLayerCard
        }
    },

    profileEducatorHeader: {
        "font-size": "14px",
        "font-weight": "600",
        "line-height": "26px"
    },

    profileEducatorMessage: {
        margin: "0",
        "font-size": "14px"
    },

    profileEducatorCloseButton: {
        position: "absolute",
        top: "0",
        [applyLocalizedProperty("right", "left", config.direction)]: "0",
        "font-size": "14px",
        opacity: ".55"
    },

    profileEducatorPopover: {
        bottom: `${arrowWidth}px`
    }
});